import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "fullscreen-table-area" }
const _hoisted_2 = { class: "table-icon" }
const _hoisted_3 = { class: "table-icon" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "expanded-row" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "lower-table-container" }
const _hoisted_8 = { class: "table-icon" }
const _hoisted_9 = { class: "table-icon" }
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { class: "expanded-row" }
const _hoisted_12 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_station_table_header_menu = _resolveComponent("station-table-header-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.hideTopDivider)
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 0,
          thickness: "1",
          opacity: "25"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isSelectionNonEmpty)
        ? (_openBlock(), _createBlock(_component_v_data_table, {
            key: 0,
            "sort-by": _ctx.sortingBy,
            "onUpdate:sortBy": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortingBy) = $event)),
            class: _normalizeClass([
          _ctx.upperTableHasIncreased ? 'colored' : '',
          'background-color-transition',
          'upper-table',
        ]),
            headers: _ctx.headers,
            "data-testid": "data-table-selected-stations",
            items: _ctx.selected,
            "checkbox-color": "primary",
            "show-select": true,
            "selectable-key": "isInUpperSelection",
            "items-per-page": -1,
            "hide-default-footer": true,
            "show-expand": "",
            "must-sort": "",
            density: "compact",
            height: _ctx.selectedTableHeight,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTableInput($event, _ctx.TableType.upper)))
          }, {
            "item.data-table-select": _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_checkbox, {
                  "model-value": true,
                  class: "d-flex align-center",
                  style: {"height":"30px","width":"30px"},
                  checked: "",
                  density: "compact",
                  "onUpdate:modelValue": (val) => _ctx.toggleStationSelection(item, val, _ctx.TableType.upper)
                }, null, 8, ["onUpdate:modelValue"])
              ])
            ]),
            "header.data-table-expand": _withCtx(() => [
              _createVNode(_component_station_table_header_menu)
            ]),
            "header.data-table-select": _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_checkbox, {
                  value: _ctx.selectAllCheckboxIsChecked,
                  indeterminate: _ctx.selectAllCheckBoxIsIntermediate,
                  "data-testid": "select-all",
                  "hide-details": "",
                  density: "compact",
                  class: "d-flex align-center",
                  style: {"height":"30px","width":"30px"},
                  onClick: _ctx.selectAll
                }, null, 8, ["value", "indeterminate", "onClick"])
              ])
            ]),
            "item.count": _withCtx(({ value }) => [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(value) + " ", 1),
                _createVNode(_component_v_tooltip, {
                  text: _ctx.t('station_table.combined_stations_tooltip'),
                  "open-delay": 200,
                  right: "",
                  "nudge-bottom": 35,
                  "content-class": "station-hint",
                  "data-testid": "tooltip-combined-stations-selected"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_icon, _mergeProps(props, {
                      style: value <= 1 && { visibility: 'hidden' },
                      color: "primary",
                      size: "x-small",
                      "data-testid": "tooltip-combined-stations-selected-icon"
                    }), {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode(" mdi-help ", -1)
                      ]))]),
                      _: 1
                    }, 16, ["style"])
                  ]),
                  _: 2
                }, 1032, ["text"])
              ])
            ]),
            "item.startDate": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(_ctx.cleanDate(value)), 1)
            ]),
            "item.endDate": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(_ctx.cleanDate(value)), 1)
            ]),
            "item.state": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(_ctx.cleanState(value)), 1)
            ]),
            "item.hasSunshine": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(_ctx.cleanBoolean(value)), 1)
            ]),
            "item.hasGlobalRadiation": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(_ctx.cleanBoolean(value)), 1)
            ]),
            "item.data-table-expand": _withCtx(({ internalItem, isExpanded, toggleExpand }) => [
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                style: _normalizeStyle(internalItem.raw.type !== 'COMBINED' && { visibility: 'hidden' }),
                "data-testid": "btn-expand-row-selected",
                onClick: ($event: any) => (toggleExpand(internalItem))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    "data-testid": "btn-expand-row-selected-icon",
                    icon: isExpanded(internalItem) ? 'mdi-chevron-down' : 'mdi-chevron-up'
                  }, null, 8, ["icon"])
                ]),
                _: 2
              }, 1032, ["style", "onClick"])
            ]),
            "expanded-row": _withCtx(({ item }) => [
              _createElementVNode("tr", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("td", { colspan: 2 }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationStore.getVisibleHeaders, (key) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: key,
                    class: "pa-0"
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subStations, (station) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: station.id,
                          class: _normalizeClass(
                    'substation-row d-flex px-4 align-center' +
                      (_ctx.stationIsDisabled(station) ? ' zamg-text-disabled' : '')
                  )
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.cleanSubstationValue(station[key])) + " ", 1),
                          (_ctx.stationIsDisabled(station) && key === 'count')
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                text: `${station.name} (${station.id}) ${_ctx.t(
                      'station_table.combined_station_not_matched'
                    )}`,
                                "open-delay": 200,
                                right: "",
                                "nudge-bottom": 35,
                                "content-class": "station-hint",
                                "data-testid": "tooltip-combined-stations-selected-substations"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props, {
                                    color: "primary",
                                    size: "x-small",
                                    "data-testid": "tooltip-combined-stations-selected-substations-icon"
                                  }), {
                                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                      _createTextVNode(" mdi-help ", -1)
                                    ]))]),
                                    _: 1
                                  }, 16)
                                ]),
                                _: 1
                              }, 8, ["text"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["sort-by", "class", "headers", "items", "height"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider, {
        class: "pa-1",
        thickness: "1",
        opacity: "25"
      }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_data_table, {
          "sort-by": _ctx.sortingBy,
          "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sortingBy) = $event)),
          class: _normalizeClass([
            _ctx.lowerTableHasIncreased ? 'colored' : '',
            'flex-grow-1',
            'background-color-transition',
            'lower-table'
          ]),
          "data-testid": "data-table-all-stations",
          headers: _ctx.hiddenHeader,
          items: _ctx.availableItems,
          "items-per-page-text": _ctx.footerOptions['items-per-page-text'],
          "items-per-page-options": _ctx.footerOptions['items-per-page-options'],
          "show-first-last-page": _ctx.footerOptions['show-first-last-page'],
          "page-text": _ctx.footerOptions['page-text'],
          loading: _ctx.isLoading,
          "loading-text": _ctx.t('loading'),
          "no-data-text": _ctx.t('no_data_available'),
          "items-per-page": _ctx.itemsPerPageDefault,
          page: _ctx.currentPage,
          "checkbox-color": "primary",
          "show-select": true,
          "disable-pagination": _ctx.disablePagination,
          "hide-default-footer": _ctx.disablePagination,
          "show-expand": "",
          "must-sort": "",
          density: "compact",
          onToggleSelectAll: _ctx.selectAll,
          "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateCurrentPage($event))),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleTableInput($event, _ctx.TableType.lower)))
        }, _createSlots({
          "item.data-table-select": _withCtx(({ isSelected, item }) => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_checkbox, {
                class: "d-flex align-center",
                style: {"height":"30px","width":"30px"},
                density: "compact",
                value: isSelected,
                color: "secondary",
                ripple: false,
                "onUpdate:modelValue": (val) => _ctx.toggleStationSelection(item, val, _ctx.TableType.lower)
              }, null, 8, ["value", "onUpdate:modelValue"])
            ])
          ]),
          "header.data-table-select": _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.isSelectionNonEmpty)
                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: 0,
                    value: _ctx.selectAllCheckboxIsChecked,
                    indeterminate: _ctx.selectAllCheckBoxIsIntermediate,
                    "hide-details": "",
                    density: "compact",
                    class: "mt-0 pa-0",
                    onClick: _ctx.selectAll
                  }, null, 8, ["value", "indeterminate", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          "item.count": _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(_toDisplayString(value) + " ", 1),
              _createVNode(_component_v_tooltip, {
                text: _ctx.t('station_table.combined_stations_tooltip'),
                "open-delay": 200,
                right: "",
                "nudge-bottom": 35,
                "content-class": "station-hint",
                "data-testid": "tooltip-combined-stations-all"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_icon, _mergeProps(props, {
                    style: value <= 1 && { visibility: 'hidden' },
                    color: "primary",
                    size: "x-small",
                    "data-testid": "tooltip-combined-stations-all-icon"
                  }), {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" mdi-help ", -1)
                    ]))]),
                    _: 1
                  }, 16, ["style"])
                ]),
                _: 2
              }, 1032, ["text"])
            ])
          ]),
          "item.startDate": _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(_ctx.cleanDate(value)), 1)
          ]),
          "item.endDate": _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(_ctx.cleanDate(value)), 1)
          ]),
          "item.state": _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(_ctx.cleanState(value)), 1)
          ]),
          "item.hasSunshine": _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(_ctx.cleanBoolean(value)), 1)
          ]),
          "item.hasGlobalRadiation": _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(_ctx.cleanBoolean(value)), 1)
          ]),
          "item.data-table-expand": _withCtx(({ internalItem, isExpanded, toggleExpand }) => [
            _createVNode(_component_v_btn, {
              icon: "",
              variant: "text",
              "data-testid": "btn-expand-row-all",
              style: _normalizeStyle(
                internalItem.raw.type !== 'COMBINED' && { visibility: 'hidden' }
              ),
              onClick: ($event: any) => (toggleExpand(internalItem))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  "data-testid": "btn-expand-row-all-icon",
                  icon: isExpanded(internalItem) ? 'mdi-chevron-up' : 'mdi-chevron-down'
                }, null, 8, ["icon"])
              ]),
              _: 2
            }, 1032, ["style", "onClick"])
          ]),
          "expanded-row": _withCtx(({ item }) => [
            _createElementVNode("tr", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("td", { colspan: 2 }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationStore.getVisibleHeaders, (key) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: key,
                  class: "pa-0"
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subStations, (station) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: station.id,
                        class: _normalizeClass(
                      'substation-row d-flex px-4 align-center' +
                        (_ctx.stationIsDisabled(station) ? ' zamg-text-disabled' : '')
                    )
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.cleanSubstationValue(station[key])) + " ", 1),
                        (_ctx.stationIsDisabled(station) && key === 'count')
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 0,
                              text: `${station.name} (${station.id}) ${_ctx.t(
                        'station_table.combined_station_not_matched'
                      )}`,
                              "open-delay": 200,
                              right: "",
                              "nudge-bottom": 35,
                              "content-class": "station-hint",
                              "data-testid": 'tooltip-combined-stations-all-substations-' + station.id
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props, {
                                  color: "primary",
                                  size: "x-small",
                                  "data-testid": 'tooltip-combined-stations-all-substations-icon-' + station.id
                                }), {
                                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode(" mdi-help ", -1)
                                  ]))]),
                                  _: 1
                                }, 16, ["data-testid"])
                              ]),
                              _: 2
                            }, 1032, ["text", "data-testid"]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]),
          "footer.page-text": _withCtx((item) => [
            _createTextVNode(_toDisplayString(`${item.pageStart} - ${item.pageStop} ${_ctx.t('of').toString()} ${
                _ctx.availableItems.length
              }`), 1)
          ]),
          _: 2
        }, [
          (!_ctx.isSelectionNonEmpty)
            ? {
                name: "header.data-table-expand",
                fn: _withCtx(() => [
                  _createVNode(_component_station_table_header_menu)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["sort-by", "class", "headers", "items", "items-per-page-text", "items-per-page-options", "show-first-last-page", "page-text", "loading", "loading-text", "no-data-text", "items-per-page", "page", "disable-pagination", "hide-default-footer", "onToggleSelectAll"])
      ])
    ])
  ]))
}